/**
 * Appels API pour l'authentification.
 */

import api from "./axiosConfig";

/**
 * Authentifie un utilisateur par email et mot de passe.
 * @param {string} email - Adresse email.
 * @param {string} password - Mot de passe.
 * @returns {Promise<Object>} Réponse avec access_token et user.
 */
export async function login(email, password) {
  const params = new URLSearchParams();
  params.append("username", email);
  params.append("password", password);

  const response = await api.post("/auth/login", params, {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return response.data;
}
